<template>
  <!-- eslint-disable -->
  <div class="action-item">
    <div class="message-item__settings-wrapper">
      <div class="d-flex flex-column align-center">
        <v-text-field
          class="message-item__settings--delay panzoom-ignore w-full"
          v-model="node.delay"
          :label="'Delay'"
          persistent-placeholder
          :placeholder="'2000'"
          :disabled="node.human"></v-text-field>
        <v-text-field
          class="message-item__settings--cssclass panzoom-ignore w-full"
          v-model="node.cssClass"
          :label="'Class'"
          persistent-placeholder
          :placeholder="''"></v-text-field>
        <div class="animated-button">
          <div class="animated-button__title">
            {{ $t("shortcodes.live_chat.enable_pulsing_buttons") }}
          </div>

          <v-switch
            class="animated-button__switch"
            v-model="node.animatedButton"
            inset
            color="primary"
            :hide-details="'auto'"
            :ripple="false">
          </v-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: "LiveChatAction",
    props: {
      node: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "@core/preset/preset/typography/index.scss";
@import "@core/preset/preset/functions.scss";

.animated-button {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  width: 100%;
  &__title {
    color: get-color("subtitle");
    @include text-body-2-bold();
    padding-left: 4px;
  }
  &__switch {
    &::v-deep {
      .v-input--selection-controls__input {
        margin-right: 0;
      }
    }
  }
}
</style>
